export default {
  savePageAsDefault: 'Set current page as Home',
  resetDefaultPage: 'Reset Home to default',
  bugReport: 'Bug report',
};
